import { useState } from "react";
import { sharepointApi, type CreateFolderResponse } from "../api/sharepoint";

/**
 * Custom hook for SharePoint folder creation. The BFF now owns the whole
 * ~90-folder project tree (one call creates it all) — see `api/sharepoint.ts`.
 */
export const useSharePoint = () => {
  const [isCreatingFolder, setIsCreatingFolder] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const createFolder = async (
    projectName: string,
    opportunityNo?: string,
  ): Promise<CreateFolderResponse> => {
    setIsCreatingFolder(true);
    setError(null);

    try {
      const response = await sharepointApi.createFolders(
        projectName,
        opportunityNo,
      );

      if (!response.success) {
        setError(response.message || "Failed to create folder");
      }

      return response;
    } finally {
      setIsCreatingFolder(false);
    }
  };

  return {
    createFolder,
    isCreatingFolder,
    error,
  };
};
